import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CommonComponentsModule } from "src/app/common-components";
import { CstToolbarModule } from "src/app/common-components/toolbar/cst-toolbar.module";
import { AdminApiModulePageComponent } from "./admin-api-module-page/admin-api-module-page.component";
import { AdminApiPageComponent } from "./admin-api-page/admin-api-page.component";
import { AdminApiModulePageToolbarDirective } from "./admin-api-module-page/directives/admin-api-module-paage-toolbar.directive";

@NgModule({
  imports: [
    CommonModule,
    CommonComponentsModule,
    CstToolbarModule,
    RouterModule,
    FormsModule,
  ],
  declarations: [AdminApiPageComponent, AdminApiModulePageComponent, AdminApiModulePageToolbarDirective],
  exports: [AdminApiPageComponent, AdminApiModulePageComponent, AdminApiModulePageToolbarDirective],
})
export class AdminCommonModule {}
